<template>
  <div class="spl-styleguide">
    <main-header />

    <br>

    <form-input :invalid="true" />
    <form-input :invalid="false" />

    <br>

    <form-datepicker :invalid="true" />
    <form-datepicker :invalid="false" />

    <br>

    <form-datepicker :invalid="true" type="datetime" />
    <form-datepicker :invalid="false" type="datetime" />

    <br>

    <form-filtered-multiselect :invalid="true" />
    <form-filtered-multiselect :invalid="false" />

    <br>
    <form-filtered-select :invalid="true" />
    <form-filtered-select :invalid="false" />

    <br>
    <form-radiobutton-group
      :options="[{label: 'Option 1', value: 1}, {label: 'Option 2', value: 0}]"
      :horizontal="true"
      :invalid="true"
      :toggle="false" />

    <form-radiobutton-group
      :options="[{label: 'Option 1', value: 1}, {label: 'Option 2', value: 0}]"
      :horizontal="true"
      :invalid="false"
      :toggle="false" />

    <form-select
      :options="[{label: 'Option 1', value: 1}, {label: 'Option 2', value: 0}]"
      :invalid="true"
      :value="1" />
    <form-select :options="[{label: 'Option 1', value: 1}, {label: 'Option 2', value: 0}]" :value="1" />

    <br>
    <br>

    <form-textarea :invalid="true" />
    <form-textarea :invalid="false" />

    <br>
    <br>
  </div>
</template>

<script>
import Helpers from '@/helpers'
export default {
  name: 'Styleguide',
  mixins: [Helpers],
  data () {
    return {
    }
  },
  computed: {
  }
}
</script>

<style lang="scss">
    @import '../variables.scss';

    .spl-styleguide {
        margin: 0 auto;
        position: relative;
        width: 100%;
    }
</style>
